/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FogPublicService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Tunnel endpoint for proxying Sentry events
     * @returns any Event forwarded successfully
     * @throws ApiError
     */
    public fogControllerTunnelV1(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/fog/public/tunnel',
        });
    }
}
